/**
 * @file CategoryHeaderGroup.tsx
 * @description Группа «Шапка категории» вкладки «Каталог → Список»
 * (phase19.16 Р2а; uiux-design-r2a §2): вид шапки схемами
 * [Только заголовок][С описанием][Баннер] (замечание пользователя 2026-10-12
 * «Нужна визуализация»), подсказка о шрифтах шапки (приёмка Р2а §7.17 п. 3),
 * поля баннера (`CategoryBannerFields`, решение 2026-10-12 «Да»; там же путь к
 * точке фокуса — она своя у каждой категории, в её карточке).
 */

import { CATEGORY_HEADER_FONT_PARTS } from "@chaiberi/shared";

import { FieldHint, GroupField } from "../../ui/settings-groups";
import { ElementFontNote } from "../../site-builder/section/elements/ElementFontNote";
import { OptionCards } from "../OptionCards";
import { CategoryBannerFields } from "./CategoryBannerFields";
import { CategoryHeaderScheme } from "./CategoryHeaderSchemes";
import { CATEGORY_HEADERS } from "./category-header-options";
import type { CatalogGroupProps } from "./CatalogListGroups";

const HEADER_CARDS = CATEGORY_HEADERS.map((h) => ({
  value: h.value,
  label: h.label,
  preview: <CategoryHeaderScheme header={h.value} />,
}));

export function CategoryHeaderGroup({ options, onChange }: CatalogGroupProps) {
  return (
    <>
      <GroupField label="Вид шапки">
        <OptionCards
          aria-label="Шапка страницы категории"
          value={options.categoryHeader}
          onChange={(categoryHeader) => onChange({ ...options, categoryHeader })}
          options={HEADER_CARDS}
        />
        <FieldHint className="mt-0">
          {options.categoryHeader === "banner"
            ? "Баннер — из фото категории. Нет фото — заголовок с описанием."
            : "Название категории и её описание — из «Каталог → Категории»."}
        </FieldHint>
      </GroupField>
      <ElementFontNote
        parts={
          options.categoryHeader === "title"
            ? CATEGORY_HEADER_FONT_PARTS.filter((p) => p.role === "heading")
            : CATEGORY_HEADER_FONT_PARTS
        }
        backLabel="Шапка категории (каталог)"
        back={{ panel: "catalog", sub: "list" }}
      />
      <CategoryBannerFields options={options} onChange={onChange} />
    </>
  );
}
